import { reclaimAccessDefaultsSchema } from "@redotech/redo-model/disputes/reclaim-access-settings";
import * as z from "zod";

export const getReclaimAccessDefaults = {
  name: "getReclaimAccessDefaults" as const,
  input: z.object({}),
  output: z.object({ defaults: reclaimAccessDefaultsSchema }),
};
